"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ThemeFactory = ThemeFactory;
exports.MuiThemeFactory = MuiThemeFactory;
exports.ProjectFactory = ProjectFactory;
exports.ChecklistSettingsFactory = ChecklistSettingsFactory;
exports.LayoutEntryFactory = LayoutEntryFactory;
exports.TaskCommentFactory = TaskCommentFactory;
exports.JobFactory = JobFactory;
exports.GetFreshLayout = GetFreshLayout;
exports.CssConfigStore = exports.TaskMetadataStore = exports.InviteStore = exports.DirectoryStore = exports.AccountStore = exports.TaskStore = exports.TaskListStore = exports.TaskListSettingsStore = exports.ProjectLayoutStore = exports.MemberStore = exports.RemoteStore = exports.ProjectStore = exports.DatabaseStore = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function ThemeFactory(id, name, isInbuilt, theme) {
  return {
    id: id,
    name: name,
    isInbuilt: isInbuilt,
    theme: theme
  };
}

function MuiThemeFactory() {
  return {
    type: 'dark',
    palette: {
      primaryColor: {
        id: 'indigo',
        shadeIndex: 6
      },
      secondaryColor: {
        id: 'orange',
        shadeIndex: 5
      },
      backgroundColor: {
        id: 'black',
        shadeIndex: 8
      },
      custom: {
        "today": '#1455c0',
        "soon": '#FF9300',
        "overdue": '#F00',
        "later": '#22B30B',
        "unreadItem": '#1455c0',
        "highPriority": 'orange'
      }
    },
    isDense: false,
    'typography': {
      useNextVariants: true
    }
  };
}

var DatabaseStore = function DatabaseStore(projects, projectLayouts, taskLists, tasks, accountConfig) {
  _classCallCheck(this, DatabaseStore);

  this.projects = projects;
  this.projectLayouts = projectLayouts;
  this.taskLists = taskLists;
  this.tasks = tasks;
  this.accountConfig = accountConfig;
};

exports.DatabaseStore = DatabaseStore;

var ProjectStore = function ProjectStore(projectName, uid, isRemote, created, updated) {
  _classCallCheck(this, ProjectStore);

  this.projectName = projectName;
  this.uid = uid;
  this.isRemote = isRemote;
  this.created = created;
  this.updated = updated;
};

exports.ProjectStore = ProjectStore;

function ProjectFactory(projectName, uid, isRemote, created, updated) {
  var coercedCreated = created === undefined ? "" : created;
  var coercedUpdated = updated === undefined ? "" : updated;
  return {
    projectName: projectName,
    uid: uid,
    isRemote: isRemote,
    created: coercedCreated,
    updated: coercedUpdated
  };
}

var RemoteStore = function RemoteStore(projectName, uid, members, projectLayout, taskLists, tasks) {
  _classCallCheck(this, RemoteStore);

  this.projectName = projectName;
  this.uid = uid;
  this.members = members;
  this.projectLayout = projectLayout;
  this.taskLists = taskLists;
  this.tasks = tasks;
};

exports.RemoteStore = RemoteStore;

var MemberStore = function MemberStore(userId, project, displayName, email, status, role) {
  _classCallCheck(this, MemberStore);

  this.project = project;
  this.userId = userId;
  this.displayName = displayName;
  this.email = email;
  this.status = status;
  this.role = role;
};

exports.MemberStore = MemberStore;

var ProjectLayoutStore = function ProjectLayoutStore(layouts, project, uid) {
  _classCallCheck(this, ProjectLayoutStore);

  this.layouts = layouts;
  this.project = project;
  this.uid = uid;
};

exports.ProjectLayoutStore = ProjectLayoutStore;

var TaskListSettingsStore = function TaskListSettingsStore(isCompleteTasksShown, sortBy, checklistSettings) {
  _classCallCheck(this, TaskListSettingsStore);

  this.isCompleteTasksShown = isCompleteTasksShown;
  this.sortBy = sortBy;
  this.checklistSettings = checklistSettings;
};

exports.TaskListSettingsStore = TaskListSettingsStore;

function ChecklistSettingsFactory(isChecklist, initialStartDate, lastRenewDate, renewInterval) {
  return {
    isChecklist: isChecklist,
    initialStartDate: initialStartDate,
    lastRenewDate: lastRenewDate,
    renewInterval: renewInterval
  };
}

function LayoutEntryFactory(taskListId) {
  return {
    i: taskListId,
    x: 0,
    y: 0,
    w: 6,
    h: 4
  };
}

var TaskListStore = function TaskListStore(taskListName, project, uid, taskListId, settings) {
  _classCallCheck(this, TaskListStore);

  this.taskListName = taskListName;
  this.project = project;
  this.uid = uid;
  this.taskListId = taskListId;
  this.settings = settings;
};

exports.TaskListStore = TaskListStore;

var TaskStore = function TaskStore(taskName, dueDate, isComplete, project, taskList, uid, dateAdded, isNewTask, isHighPriority, metadata, assignedTo, commentPreview) {
  _classCallCheck(this, TaskStore);

  this.taskName = taskName;
  this.dueDate = dueDate;
  this.isComplete = isComplete;
  this.project = project;
  this.taskList = taskList;
  this.uid = uid;
  this.dateAdded = dateAdded;
  this.isNewTask = isNewTask;
  this.isHighPriority = isHighPriority;
  this.metadata = metadata;
  this.assignedTo = assignedTo;
  this.commentPreview = commentPreview;
};

exports.TaskStore = TaskStore;

var AccountStore = function AccountStore(uid, favourteProjectId) {
  _classCallCheck(this, AccountStore);

  this.uid = uid;
  this.favourteProjectId = favourteProjectId;
};

exports.AccountStore = AccountStore;

var DirectoryStore = function DirectoryStore(email, displayName, userId) {
  _classCallCheck(this, DirectoryStore);

  this.email = email;
  this.displayName = displayName;
  this.userId = userId;
};

exports.DirectoryStore = DirectoryStore;

var InviteStore = function InviteStore(projectName, targetUserId, sourceUserId, sourceEmail, sourceDisplayName, projectId, role) {
  _classCallCheck(this, InviteStore);

  this.projectName = projectName;
  this.targetUserId = targetUserId;
  this.sourceUserId = sourceUserId;
  this.sourceEmail = sourceEmail;
  this.sourceDisplayName = sourceDisplayName;
  this.projectId = projectId;
  this.role = role;
};

exports.InviteStore = InviteStore;

var TaskMetadataStore = function TaskMetadataStore(createdBy, createdOn, updatedBy, updatedOn, completedBy, completedOn) {
  _classCallCheck(this, TaskMetadataStore);

  this.createdBy = createdBy;
  this.createdOn = createdOn;
  this.updatedBy = updatedBy;
  this.updatedOn = updatedOn;
  this.completedBy = completedBy;
  this.completedOn = completedOn;
};

exports.TaskMetadataStore = TaskMetadataStore;

function TaskCommentFactory(uid, text, mentions, created, createdBy, seenBy, displayName) {
  return {
    uid: uid,
    text: text,
    mentions: mentions,
    created: created,
    createdBy: createdBy,
    seenBy: seenBy,
    timestamp: new Date(),
    displayName: displayName
  };
}

function JobFactory(type, payload) {
  return {
    type: type,
    payload: payload
  };
}

function GetFreshLayout(taskListWidgetId) {
  return {
    i: taskListWidgetId,
    x: 0,
    y: 0,
    w: 6,
    h: 4,
    isFresh: true
  };
}

var CssConfigStore = {
  '--primary-color': '',
  '--background-color': '',
  '--surface-color': '',
  '--surface-color-alternate': '',
  '--primary-active-text-color': '',
  '--primary-inactive-text-color': '',
  '--primary-hover-color': '',
  '--primary-divider-color': '',
  '--alternate-active-text-color': '',
  '--alternate-inactive-text-color': '',
  '--loading-spinner-primary-color': '',
  '--loading-spinner-secondary-color': '',
  '--button-background-top-color': '',
  '--button-background-bottom-color': '',
  '--task-checkbox-color': '',
  '--task-text-color': '',
  '--task-selected-color': '',
  '--task-hover-color': '',
  '--task-divider-color': '',
  '--overdue-color': '',
  '--soon-color': '',
  '--later-color': '',
  '--today-color': '',
  '--important-color': '',
  '--due-date-text-color': '',
  '--due-date-circle-color': '',
  '--assignee-background-color': '',
  '--assignee-text-color': '',
  '--task-list-header-text-color': '',
  '--task-list-header-selected-text-color': '',
  '--task-list-header-background-color': '',
  '--task-list-header-background-selected-color': '',
  '--scrollbar-track-color': '',
  '--scrollbar-thumb-color': '',
  '--database-synced-color': '',
  '--database-updates-pending-color': '',
  '--unread-comment-color': ''
};
exports.CssConfigStore = CssConfigStore;



//////////////////
// WEBPACK FOOTER
// ../handball-libs/libs/pounder-stores/index.js
// module id = 157
// module chunks = 0